import { apiRequest } from './apiWrapper'
import { API_METHOD, API_END_POINT } from '../utils/constants'
import { isAndroidApp } from '../utils/helper'
import { getCookie } from '../utils/cookiesHelper'
import { useLanguage } from 'shared-ui/utils/languageProvider'

export async function fetchPlanDetails(entitlement_groups) {
  const params = new URLSearchParams()
  if (entitlement_groups?.length) {
    entitlement_groups.forEach((element) => {
      params.append('entitlement_groups', element)
    })
  }

  const countryCode = localStorage.getItem('currentCountry')
  const response = await apiRequest({
    method: API_METHOD.Get,
    skipCache: true,
    url: API_END_POINT.getPaymentPlans,
    params,
    headers: {
      'X-Country': countryCode
    }
  })
  return response
}
export async function fetchActivePlan() {
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.getActivePlans
  })
  return response
}

export async function cancleSubscriptionApi(subscription_ids) {
  const accessToken = localStorage.getItem('access')
  const urlParams = new URLSearchParams(window.location.search)
  const authToken = urlParams.get('auth_token')

  const response = await apiRequest({
    method: API_METHOD.Post,
    url: API_END_POINT.cancleSubscription,
    data: { subscription_ids },
    headers: {
      'x-api-token': isAndroidApp ? authToken : accessToken
    }
  })
  return response
}

export async function createPendingApi(payload) {
  const accessToken = localStorage.getItem('access')
  const urlParams = new URLSearchParams(window.location.search)
  const authToken = urlParams.get('auth_token')
  const androidCurrentCountry = urlParams.get('current_country')
  const countryCode = isAndroidApp ? androidCurrentCountry: localStorage.getItem('currentCountry')
  const response = await apiRequest({
    method: API_METHOD.Post,
    url: API_END_POINT.pendingSubscription,
    data: payload,
    headers: {
      'x-api-token': isAndroidApp ? authToken : accessToken,
      'X-Country': countryCode
    }
  })
  return response
}

export async function fetchProductDetails() {
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.productDetails
  })
  return response
}

export async function fetchPlanEntitlement() {
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.planEntitlement
  })
  return response
}

export async function fetchVendor() {
  const accessToken = localStorage.getItem('access')
  const urlParams = new URLSearchParams(window.location.search)
  const authToken = urlParams.get('auth_token')
  const token = isAndroidApp ? authToken : (accessToken || authToken)
  const androidCurrentCountry = urlParams.get('current_country')
  const countryCode = isAndroidApp ? androidCurrentCountry: localStorage.getItem('currentCountry')

  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.allVendorPayment,
    headers: {
      'x-api-token': token,
      'X-Country': countryCode
    }
  })
  return response
}

export async function fetchVendorPaymentDetails() {
  const countryCode = localStorage.getItem('currentCountry')
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.vendorPaymentDetails,
    headers: {
      'X-Country': countryCode
    }
  })
  return response
}

export async function createTransactionApi({
  payment_type_id,
  subscription_ids,
  authToken,
  androidCurrentCountry
}) {
  const accessToken = localStorage.getItem('access')
  const countryCode = isAndroidApp ? androidCurrentCountry: localStorage.getItem('currentCountry')
  const response = await apiRequest({
    method: API_METHOD.Post,
    url: API_END_POINT.createTransaction,
    data: { payment_type_id, subscription_ids },
    headers: {
      'x-api-token': isAndroidApp ? authToken : accessToken,
      'X-Country': countryCode
    }
  })
  return response
}

export async function createSubscription(data, authTokenForAndroid,androidCurrentCountry) {
  const accessToken = localStorage.getItem('access')
  const countryCode = isAndroidApp ? androidCurrentCountry: localStorage.getItem('currentCountry')
  const response = await apiRequest({
    method: API_METHOD.Post,
    url: API_END_POINT.createSubscription,
    data: data,
    headers: {
      'x-api-token': isAndroidApp ? authTokenForAndroid : accessToken,
      'X-Country': countryCode
    }
  })
  return response
}

export async function fetchTransactionStatus(transaction_id) {
  const countryCode = localStorage.getItem('currentCountry')
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.getTransactionStatus,
    params: { transaction_id },
    headers: {
      'X-Country': countryCode
    }
  })
  return response
}

export async function fetchSubscriptionStatus() {
  const accessToken = localStorage.getItem('access')
  const urlParams = new URLSearchParams(window.location.search)
  const authToken = urlParams.get('auth_token')
  const androidCurrentCountry = urlParams.get('current_country')
  const countryCode = isAndroidApp ? androidCurrentCountry: localStorage.getItem('currentCountry')

  const headers = {
    'x-api-token': isAndroidApp ? authToken : accessToken,
    'X-Country': countryCode
  }
  
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.getSubscriptionStatus,
    skipCache:true,
    headers
  })
  return response
}
export async function fetchSubscriptionTransactions() {
  const accessToken = localStorage.getItem('access')
  const countryCode = localStorage.getItem('currentCountry')

  const headers = {
    'x-api-token': accessToken,
    'x-api-client': 'CZgbPYnmcj5iyEH9tg0GYvB4lm9gGQ9qs6jQwllV',
    'X-Country': countryCode
  }

  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.getSubscriptionTransactions,
    headers
  })
  return response
}

export async function fetchPriceBreakup(product_id, discount_code = '') {
  const accessToken = localStorage.getItem('access')
  const urlParams = new URLSearchParams(window.location.search)
  const authToken = urlParams.get('auth_token')
  const params = {
    product_id,
    discount_code
  }
  const androidCurrentCountry = urlParams.get('current_country')
  const countryCode = isAndroidApp ? androidCurrentCountry: localStorage.getItem('currentCountry')
  const headers = {
    'x-api-token': isAndroidApp ? authToken : accessToken,
    'X-Country': countryCode
  }

  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.priceBreakup,
    params,
    headers,
    
  })
  return response
}

export async function fetchSubscribeButtonStatus() {
  const accessToken = localStorage.getItem('access')
  const urlParams = new URLSearchParams(window.location.search)
  const authToken = urlParams.get('auth_token')
  const androidCurrentCountry = urlParams.get('current_country')
  const countryCode = isAndroidApp ? androidCurrentCountry: localStorage.getItem('currentCountry')
  const headers = {
    'x-api-token': isAndroidApp ? authToken : accessToken,
    'X-Country': countryCode
  }

  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.subscriptionButtonState,
    skipCache:true,
    headers
  })
  return response
}

export async function checkPaymentStatus({ transaction_id }) {
  const accessToken = localStorage.getItem('access')
  const urlParams = new URLSearchParams(window.location.search)
  const authToken = urlParams.get('auth_token')
  const androidCurrentCountry = urlParams.get('current_country')
  const countryCode = isAndroidApp ? androidCurrentCountry: localStorage.getItem('currentCountry')
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: `${API_END_POINT.checkPaymentStatus}?transaction_id=${transaction_id}`,
    headers: {
      'x-api-token': isAndroidApp ? authToken : accessToken,
      'X-Country': countryCode
    }
  })
  return response
}
